<template>
    <b-card
        class="mb-2"
        :header= titulo>
        <b-card-text>CPF: {{$helpers.formatCPF(cpf_requerente)}}</b-card-text>
        <b-card-text>Nome: {{nome_completo}}</b-card-text>
        <b-card-text>Situação:
            <b-badge v-if='situacao == "A"' variant="success">Ativo</b-badge>
            <b-badge v-else-if='situacao == "I"' variant="danger">Inativo</b-badge>
            <b-badge v-else-if='situacao == "P"' variant="warning">Aguardando Confirmação</b-badge>
        </b-card-text>
    </b-card>                   
</template>

<script>

export default {
    
    props: { 
        titulo: { type: String, default: "Beneficiário" },
        cpf_requerente: { type: String, default: "" },          
        nome_completo: { type: String, default: "" },
        situacao: { type: String, default: "" },
    },

}
</script>
